import Headroom from "headroom.js";

// http://wicky.nillia.ms/headroom.js/

export default class Navigation {

    constructor() {
        this.headroom = null;
        this.isShown = false;

        this.selector = '#navigation';
        this.$el = null;
        this.$button = null;

        // functions bound to event listeners
        this.toggle = this.toggle.bind(this);
        this.showOnLarge = this.showOnLarge.bind(this);

        this.init();
    }

    init() {
        this.$el = document.querySelector(this.selector);
        this.$button = this.$el.querySelector("button");

        if(this.$el) {
            this.headroom = new Headroom(this.$el, {
                offset: 80
            });

            this.headroom.init();
            this.$button.addEventListener("click", this.toggle)
            window.addEventListener("resize", this.showOnLarge);
        }
    }

    destroy() {
        this.headroom.destroy();
        this.$button.removeEventListener("click", this.toggle)
        window.removeEventListener("resize", this.showOnLarge);
    }

     toggle() {
        this.isShown = !this.isShown;

        if (this.isShown) {
            this.show();
        } else {
            this.hide();
        }
    }

    show() {
        this.headroom.freeze();
        this.$el.classList.add("is-shown");
    }

    hide() {
        this.headroom.unfreeze();
        this.$el.classList.remove("is-shown");
    }

    showOnLarge() {
        if (window.innerWidth >= 1024) {
            this.isShown = false;
            this.hide();
        }
    }
}
